// parentPath is where Back goes when there's no in-app history to return to
// (the first page in the tab: a bookmark, a shared link, a new tab): one level
// up the URL. A tab page (/herd/animals) goes home, not to /herd, which would
// just redirect back to the same tab.
export const parentPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length <= 2) return '/';
  segments.pop();
  const up = '/' + segments.join('/');
  // URLs with no page one level up.
  if (/^\/weight\/lots\/[^/]+\/animals$/.test(up)) return up.replace(/\/animals$/, '');
  if (up === '/lists/items') return '/lists';
  // /…/protocols/:id/edit → the protocol list (there's no page per protocol).
  if (/^\/(reproduction\/protocols|herd\/plans|weight\/plans)\/[^/]+$/.test(up)) return up.replace(/\/[^/]+$/, '');
  return up;
};
